/* eslint-disable */
import { memo, useState } from 'react';
import { IconButton, makeStyles, Menu } from '@material-ui/core';
import { ReactComponent as MenuIcon } from '../../../../assets/icons/expand_circle_down.svg';
import cx from 'classnames';

const useStyles = makeStyles(() => ({
  container: {
    position: 'relative',
    width: '100%',
    height: '100%',
  },
  shimmer: {
    maxHeight: 20,
    borderRadius: '0.25rem',
    position: 'absolute',
    display: 'flex',
    backgroundColor: '#dee2e6',
    visibility: 'visible',
    width: 30,
    height: 34,
    left: '50%',
    top: '50%',
    transform: 'translate(-50%, -50%)',
  },
  button: {
    minHeight: '100%',
    width: '100%',
    height: '100%',
    position: 'absolute',
    top: 0,
    bottom: 0,
    left: 0,
    right: 0,
  }
}));
const MoreButton = memo(function MoreButton({ row, actions, canShowSkeletons }) {
  const classes = useStyles();
  const [anchorEl, setAnchorEl] = useState(null);
  const open = Boolean(anchorEl);

  const handleClose = (event) => {
    event.preventDefault();
    event.stopPropagation();
    event.nativeEvent.stopImmediatePropagation();
    setAnchorEl(null);
  };

  const handleClick = (event) => {
    event.preventDefault();
    event.stopPropagation();
    event.nativeEvent.stopImmediatePropagation();
    setAnchorEl(event.currentTarget);
  };

  return <div className={cx(classes.container, 'more-button')}>
    {row.original.showShimmer || canShowSkeletons
    ? <div className={classes.shimmer} />
    : <div className={classes.button} >
      <IconButton id='basic-button'
                  aria-controls={open ? 'basic-menu' : undefined}
                  aria-haspopup='true'
                  aria-expanded={open ? 'true' : undefined}
                  variant='contained'
                  onClick={handleClick}
                  size='small'
                  style={{
                    width: '100%',
                    height: '100%',
                    borderRadius: 0,
                  }}
      >
        <MenuIcon />
      </IconButton>
      <Menu
        id='basic-menu'
        anchorEl={anchorEl}
        open={open}
        onClose={handleClose}
        MenuListProps={{
          'aria-labelledby': 'basic-button',
        }}
      >
        {actions && actions({ row, setAnchorEl })}
      </Menu>
    </div>}
  </div>;
});

export default MoreButton;
